export default "__VITE_ASSET__19BYtcac__"